import { useId } from "react";

const Dropdown = ({
  label,
  options,
  onSelect,
  headLabel,
  error,
  disabled,
  classes,
  value,
  required,
  loading = false,
  name,
}) => {
  const generatedId = useId();
  const selectId = name || generatedId;
  const errorId = `${selectId}-error`;

  const handleChange = (e) => {
    onSelect(e.target.value);
  };

  const getOptionValue = (option) => {
    return typeof option === "object" && option.value !== undefined
      ? String(option.value)
      : String(option);
  };

  const getOptionLabel = (option) => {
    return typeof option === "object" && option.label !== undefined
      ? String(option.label)
      : String(option);
  };

  const visibleLabel = headLabel || label;

  return (
    <div className={`w-full flex flex-col gap-y-2 ${classes || ""}`}>
      {visibleLabel && (
        <label
          htmlFor={selectId}
          className="block text-base font-medium text-black"
        >
          {headLabel || label}
          {required && (
            <span className="text-red-700 ml-1" aria-hidden="true">
              *
            </span>
          )}
          {required && <span className="sr-only"> (required)</span>}
        </label>
      )}

      <div className="relative w-full">
        <select
          id={selectId}
          name={name}
          value={value || ""}
          onChange={handleChange}
          disabled={disabled || loading}
          required={required}
          aria-required={required || undefined}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? errorId : undefined}
          className={`w-full rounded-md border border-gray-200 px-4 py-2.5 appearance-none bg-white text-base focus:outline-none focus:ring-2 focus:ring-blue-600 ${
            disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          <option value="" disabled>
            {loading ? "Loading..." : label || "Select an option"}
          </option>

          {options.length > 0 ? (
            options.map((option, index) => (
              <option key={index} value={getOptionValue(option)}>
                {getOptionLabel(option)}
              </option>
            ))
          ) : (
            <option disabled>No options available</option>
          )}
        </select>
        <div
          className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-700"
          aria-hidden="true"
        >
          <svg
            className="h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>
      {error && (
        <p id={errorId} className="text-sm text-red-700 mt-1" role="alert">
          {error.message}
        </p>
      )}
    </div>
  );
};

export default Dropdown;
